import React__default, { forwardRef } from 'react';
import SvgIcon from '@mui/material/SvgIcon';

const MenuIcon = forwardRef((props, ref) => {
    return (React__default.createElement(SvgIcon, Object.assign({}, props, { ref: ref }),
        React__default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "23", height: "18", viewBox: "0 0 23 18" },
            React__default.createElement("g", { "data-name": "Group 9056" },
                React__default.createElement("g", { "data-name": "Group 8982" },
                    React__default.createElement("path", { "data-name": "Line 311", transform: "translate(1 .999)", fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "2px", d: "M0 0h21" }),
                    React__default.createElement("path", { "data-name": "Line 312", transform: "translate(1 8.999)", fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "2px", d: "M0 0h21" }),
                    React__default.createElement("path", { "data-name": "Line 313", transform: "translate(1 16.999)", fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "2px", d: "M0 0h21" }))))));
});

export { MenuIcon };
//# sourceMappingURL=MenuIcon.js.map
